const MaskList = [
    {
        id: 13260,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp2u5VAGiNWlGp6_QsLcZrCT1KRape47dO8e8A=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u6211\u611b\u5927\u71b1\u9580",
        channelId: "UCkELMMBdy4gPj6ooQwYJ-yg",
        value: 739722,
        rank: 1
    },
    {
        id: 17669,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp3aKOEmpqcy7c5YJpzSdq9ipAJyBD6aYsutUg=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u5728\u4e0d\u6b7b",
        channelId: "UCqAYPUHgXuzsNlYNIzItfAQ",
        value: 553884,
        rank: 2
    },
    {
        id: 13874,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp2s68iqwX9LEE8_dhaQ3Udwk95mhUYf9TEShA=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u6771\u68ee\u8d85\u8996",
        channelId: "UCL7bheTrjSa9wipFYHw_6gA",
        value: 261917,
        rank: 3
    },
    {
        id: 23922,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp0RO21mOVBX1P1hwkXB_9mSpB_PfGT1UsH9Ew=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u5154\u982d(TuTou)",
        channelId: "UCYjd8tJecQPnyEbaqukg9mg",
        value: 185436,
        rank: 4
    },
    {
        id: 2157,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp0Vv8qzidJGRQDCj2eDG24BIJeMf_0XB7q2Nw=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u963f\u8129Marshall",
        channelId: "UC2C6JFuNNe4iB4mWtH6BzoA",
        value: 94709,
        rank: 5
    },
    {
        id: 19885,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp2oFhBArTJ0hBcRX4xG0p8kXydIP5xFH9DW=s240-mo-c-c0xffffffff-rj-k-no",
        title: "Lessons from ",
        channelId: "UCt8mg-YL_ikTAJKuZ8GMtqg",
        value: 79667,
        rank: 6
    },
    {
        id: 17189,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp1BpzR5jAddwIfmUBApBLG0YNR6qmle33ziEw=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u65b0\u53f0\u7063\u52a0",
        channelId: "UCpmAcCUZtDEZNQWmqwX7DxQ",
        value: 36670,
        rank: 7
    },
    {
        id: 22360,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp30aIQcPUJMQy9giNP3jem-SnLPFNRYLyav=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u7d42\u6975\u9ad8\u6821",
        channelId: "UCWhtRkOvtdpND8M_daR5jwA",
        value: 28553,
        rank: 8
    },
    {
        id: 13181,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp3UtcYqSRbjxRlsPbAMvsgyJ82T9Mn-Fbgv-w=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u7b4b\u8089\u5abd\u5abd",
        channelId: "UCKbDbLVREbS_jSl5Ys9ZGaA",
        value: 24956,
        rank: 9
    },
    {
        id: 9843,
        country: "TW",
        avatar:
            "https://yt3.ggpht.com/a-/AJLlDp0CZbJkvHFq9p7HPhoXH2iN8pnzagHAX2zJYA=s240-mo-c-c0xffffffff-rj-k-no",
        title: "\u7dad\u5c3c",
        channelId: "UCFWziUD4axmUxlWzM7oArKg",
        value: 24813,
        rank: 10
    }
];
export default MaskList;



// WEBPACK FOOTER //
// ./src/Ranking/MaskList.js